/**
 * The i18n translations inspector overlay (TEC-465)'s opt-in cookie name, single-sourced so the
 * hamburger-menu toggle (translation-reviewer-facing), the backoffice testing page (admin-facing),
 * the client mount (InspectorMount.tsx), and the SSR static-route check (vike-handler.ts) all
 * agree. Managed on the shared cookie mechanism in read-feature-flag.ts. Not itself gated by
 * anything — visibility of a toggle for this cookie is what's role-gated, see
 * translation-reviewer-role.ts.
 */
export const I18N_INSPECTOR_COOKIE = 'dev_enable_i18n_inspector';
